import { useTranslation } from 'react-i18next'
import { UpcomingPayroll } from '../../../../../redux/types'
import { PayrollHeader, StatusMessage, UploadedFilesContainer, PayrollActions } from '..'

interface SuccessContentProps {
  upcomingPayroll: UpcomingPayroll
}

const SuccessContent = ({
  upcomingPayroll
}: SuccessContentProps) => {
  const { t } = useTranslation(['common', 'payrolls'])

  return (
    <>
      <PayrollHeader
        labelText={upcomingPayroll.offCycle ? t('offCyclePayment', { ns: 'payrolls' }) : t('upcomingPayday', { ns: 'payrolls' })}
        paymentDate={upcomingPayroll.paymentDate}
      />
      <UploadedFilesContainer
        errorsExist={false}
        upcomingPayroll={upcomingPayroll}
      />
      <StatusMessage
        message={t('successTitle', { ns: 'payrolls' })}
      />
      <PayrollActions
        upcomingPayroll={upcomingPayroll}
      />
    </>
  )
}

export default SuccessContent
